<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import shareImpl from './utils/wxApi'


Vue.use(Vant)
export default {
  name: 'App',

mounted(){
    console.log('store',this.$store)
    let terminalCode = Number(this.$route.query.s)
    // if(terminalCode){
    this.$store.dispatch('admin/getValTerminalByCode',{terminalCode})
// }
    //当页面加载完成后触发该函数
    window.onload = function () {
      //e.preventDefault() --- 阻止默认事件
      //当一个手指放在屏幕上时，会触发touchstart事件。如果另一个手指又放在了屏幕上，则会先触发gesturestart事件，随后触发基于该手指的touchstart事件。
      document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
      });

      //在单个元素上单击两次 --- dblclick
      document.addEventListener('dblclick', function (e) {
        e.preventDefault();
      });

      //一个手指放在屏幕上时，会触发touchstart事件
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });

      //如果一个或两个手指在屏幕上滑动，将会触发gesturechange事件
      //但只要有一个手指移开，则会触发gestureend事件，紧接着又会触发toucheend事件。
      var lastTouchEnd = 0;
      document.addEventListener('touchend', function (event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    };
},
watch: {
    // 监听 $route 变化调用分享链接
    // "$route"(to, from) {
    //   console.log('changeRoute');
    //  shareImpl({shareTitle:'分享测试',
    //            shareDesc: '分享测试描述',
    //            shareUrl: location.href,
    //            shareImg: 'https://rdt.h5.mogugu.com/static/img/bannerBottom.ef9f362.jpg'
    //                 })
    // }
  }

}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.lswidth{
  width:6.9rem;
  height:0.88rem;
  font-size:0.26rem;
  border:1px solid #000;
}
input{
  padding:0;
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue